import axios from 'axios';

export const PENDING_UPLOAD_CHECK = 'PENDING_UPLOAD_CHECK';
export const BULK_ADHERENCES_CONTACT = 'BULK_ADHERENCES_CONTACT';
export const VERIFICATION_FINAL_RESP = 'VERIFICATION_FINAL_RESP';

export function checkExistingUpload( id = '', time ) {
	return ( dispatch ) => {
		const url = `${wpApiSettings.root}isda/v1/adherence-check-pending-upload?contact=${id}`;
		axios.get( url, {
			timeout: time // Timeout after 5 seconds
		} ).then( response => {
			dispatch( {
				          type: PENDING_UPLOAD_CHECK, payload: response.data
			          } );
		} );
	};
}

export function bulkAdherencesContact( id = '', payload = '', protocol = '' ) {
	return ( dispatch ) => {
		const url = `${wpApiSettings.root}isda/v1/adherence-contact-details?contact=${id}&protocol=${protocol}`;
		axios.post( url, payload, {
			timeout: 7000
		} ).then( response => {
			dispatch( {
				          type: BULK_ADHERENCES_CONTACT, payload: response.data
			          } );
		} );
	};
}

export function verificationAndFinalMessage( id = '', protocol = '' ) {
	return ( dispatch ) => {
		const url = `${wpApiSettings.root}isda/v1/verification-final-response?contact=${id}&protocol=${protocol}`;
		axios.post( url, {
			timeout: 5000
		} ).then( response => {
			dispatch( {
				          type: VERIFICATION_FINAL_RESP, payload: response.data
			          } );
		} );
	};
}
